module.exports = __webpack_public_path__ + "img/header-hello.7934f50e.png";